/*
 * Copyright (c) 2020  Apricad LLC. All Rights Reserved.
 */

import * as React from "react";
import { connect } from "react-redux";
import createStyles from "@material-ui/core/styles/createStyles";
import withStyles, { WithStyles } from "@material-ui/core/styles/withStyles";
import Snackbar from "@material-ui/core/Snackbar";

import { clearToast, ToastType, ApricotAction } from "client/actions/modal.ts";

const styles = (theme: any) =>
  createStyles({
    toastNormal: {
      background: theme.palette.secondary.dark,
    },
    toastWarning: {
      background: theme.palette.warning.main,
    },
  });

interface Props extends WithStyles<typeof styles> {
  clearToast: ApricotAction;
  toast: ToastType;
  classes: any;
}
const ToastBase: React.FC<Props> = ({ clearToast, toast, classes }: Props) => {
  if (toast) {
    const { type, message } = toast;
    const { toastNormal, toastWarning } = classes;
    return (
      <Snackbar
        open={toast ? true : false}
        onClose={clearToast}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        ContentProps={{
          classes: { root: type === "normal" ? toastNormal : toastWarning },
        }}
        message={<span id="message-id">{message}</span>}
        autoHideDuration={2000}
      />
    );
  } else {
    return <></>;
  }
};

function mapStateToProps(store: any) {
  return {
    toast: store.state_modal.toast,
  };
}

const base: any = ToastBase;
export const Toast = withStyles(styles)(
  connect(mapStateToProps, { clearToast })(base),
);
